/*
 * @CopyRight    : 广州仰望星空云科技有限公司
 * @Author       : Kyle
 * @Email        : linyukai@xinyu668.com
 * @CreateTime   : 2023-08-17 18:27:29
 * @Description  : 全局Toast
 */
import { showToast, showLoadingToast } from 'vant';
import 'vant/es/toast/style';
import { typeIs } from '@ywxk/util/validate'
import { constConf } from '@GLOBAL/constConf';
import { jsonStringify } from '@ywxk/util/format';


const { IS_DEBUG } = constConf

/**
 * @description: toast提示
 * @param      {*} data Error对象|字符串|请求失败参数
 */
export const toast = (data) => {
  // console.error(data)
  // 防止异常入参
  if (!data) return console.error('toast未知入参：', data)
  // 正常输出，支持Toast传入对象
  if (typeIs('String', data)) return showToast(data)
  // showToast 参数可接受一个对象
  if (data.message && !data.allDescription) return showToast(data.message)
  // 接口错误类型,可能没处理成Error类型,所以针对字段处理,服务端约定大于一万才暴露真实错误
  if (data.message && data.description) return showToast(data?.allDescription?.ret < 1e4 ? data.message : IS_DEBUG ? data.description : data.description.replace(/\[(.*?)\]/g, ''))
  // 主动上报
  return Promise.reject(jsonStringify(data))
}

/**
 * 常用于加载型toast,会被普通toast覆盖,有这种情况就不需要清除
 * @param opt 查看Toast.loading参数
 * @returns 清除toast函数
 */
export const toastLoading = (opt) => {
  // 只传文案需要兼容
  if (typeIs('String', opt)) {
    opt = {
      message: opt,
    }
  }

  const ins = showLoadingToast({
    loadingType: 'spinner',
    duration: 0, // 展示时长(ms)，值为 0 时，toast 不会消失
    forbidClick: true,
    ...opt,
  })
  return { clear: ins.close }
}

export default toast
